import React, { useEffect, useState, Fragment } from 'react';
import { Button, Card, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { BsCloudUpload } from 'react-icons/bs'
import { FaFileAlt, FaSyncAlt } from 'react-icons/fa'
import { serviceGetDetalles, serviceGetEstadoSituacion, serviceGetProveedores } from '../../../api/api-aprobacion-objecion';
import { serviceGetDatosImplicado } from '../../../api/api-recuperacion-cobro';
import { formatoMonto, formatoTestUS, percent, isValidParam, convertirFecha, formatoTest, moneyPunto} from '../../../common/Formatos';
import Destinatarios from './destinatarios';
import { Auth, LoadingComponent } from 'recupero-comunes'

const FormAprobacionObjecion = ({ cfg_form, formik, contactoCIA, implicado, estadoSituacion, setEstadoSituacion, setGlosaMotivo, setClasRespuesta, fileRef, idCaso, destinatarios, setDestinatarios, setValidaAbogados, handleCargaDocumento, uploadSuccessTrigger }) => {
    const { values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldError, setFieldTouched } = formik;
    const [respuestas, setRespuestas] = useState([]);
    const [motivos, setMotivos] = useState([]);
    const [tiposSiniestro, setTiposSiniestro] = useState([]);
    const [abogados, setAbogados] = useState([]);
    const [stateMontoCosto, setStateMontoCosto] = useState("");
    const [stateMontoRecobro, setStateMontoRecobro] = useState("");
    const [showAbogados, setShowAbogados] = useState(false);
    const [blur, setBlur] = useState(false);
    const [cntCargasRespaldo, setCntCargasRespaldo] = useState(null);
    const { rutOrganizacion } = Auth.currentUser();

    useEffect(() => {
        getMotivos();
        getRespuestas();
        getTipoSiniestro();
    }, [])

    useEffect(() => {
        if (implicado) {
            setFieldValue('montoNetoApr', formatoMonto(Math.round(implicado.MontoCosto)));
            setFieldValue('porcConvenio', implicado.PorConvenido);
            setFieldValue('montoRecobro', formatoMonto(Math.round(implicado.MontoRecobro)));

            setFieldValue('clasificaRespuesta', isValidParam(implicado['ClasRpta']) ? implicado.ClasRpta : "");
            setFieldValue('motivoRespuestaCIA', isValidParam(implicado['CodMotivoRespuestaCarta']) ? implicado.CodMotivoRespuestaCarta : "");
            isValidParam(implicado['MotivoRespuestaCarta']) ? setGlosaMotivo(implicado.MotivoRespuestaCarta) : "";
            setFieldValue('fechaRespuesta', isValidParam(implicado['FechaRespuestaCartaFormat']) ? convertirFecha(implicado.FechaRespuestaCartaFormat) : hoy());
            
            setStateMontoCosto(implicado?.MontoCosto ? implicado?.MontoCosto : "");
            setStateMontoRecobro(implicado?.MontoRecobro ? implicado?.MontoRecobro : "");

            if (implicado && isValidParam(implicado['PorcConvAprob']) && implicado.PorcConvAprob > 0) {
                setFieldValue('porcConvenio', implicado.PorcConvAprob);
                setFieldValue('montoRecobro', formatoMonto(Math.round(implicado.RecobroAprob)));
                setFieldValue('montoNetoApr', formatoMonto(Math.round(implicado.MontoNetoApr)));

                setStateMontoCosto(implicado?.MontoNetoApr ? implicado?.MontoNetoApr : "");
                setStateMontoRecobro(implicado?.RecobroAprob ? implicado?.RecobroAprob : "");
            }    
            setFieldValue('tipoSiniestroIM', implicado?.TipoSiniestroIM ?? "280001");
            setFieldValue('correlativoSura', implicado?.CorrelativoCia ?? "");
            setCntCargasRespaldo(implicado?.CntCargasRespaldoObjCIAs);

            if (isValidParam(implicado['ClasRpta']) && isValidParam(implicado['CodMotivoRespuestaCarta']) && implicado.ClasRpta == "227027" && implicado.CodMotivoRespuestaCarta == "228029") {
                getAbogados();
                handleAbogados(true);
            }
        }
    }, [implicado])
    const getTipoSiniestro = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 280 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setTiposSiniestro(response);
    }
    /*useEffect(() => {
        if (implicado && values.porcConvenio !== "") {
            const recobro = Number(implicado.MontoCosto) * Number(values.porcConvenio) / 100;
            const recobroMoneda = (implicado.CodMonedaRecobro === 30001) ? formatoTestUS(recobro, false) : formatoTestUS(recobro, true);
            
            setFieldValue('montoRecobro', formatoMonto(recobroMoneda));
        }
    }, [values.porcConvenio])*/

    useEffect(() => {
        if (values.motivoRespuestaCIA !== "") getEstadoSituacion()
    }, [values.motivoRespuestaCIA])

    useEffect(() => {
        if (uploadSuccessTrigger > 0) refreshCntCargasRespaldo();
    }, [uploadSuccessTrigger])

    const getRespuestas = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 227 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setRespuestas(response);
    }

    const getMotivos = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 228 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setMotivos(response);
    }

    const getEstadoSituacion = async () => {
        let query = Buffer.from(JSON.stringify({ clasificacion: values.clasificaRespuesta, motivo: values.motivoRespuestaCIA })).toString('base64');
        const response = await serviceGetEstadoSituacion(query);
        
        setEstadoSituacion(response);
    }
    const handleMotivo = (value) => {
        motivos.forEach(motivo => { 
            if (motivo.id === Number(value)) { setGlosaMotivo(motivo.nombre) }
        })
        
        if (values.clasificaRespuesta == "227027" && value == "228029") {
            getAbogados();
            handleAbogados(true);
        } else {
            handleAbogados(false);
        }
    }
    const handleAbogados = (value) => {
        setShowAbogados(value);
        setValidaAbogados(value);
    }
    const getAbogados = async () => {
        const query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, rol: '0070ABOEXT', tipoPersona: '0080PROVE00' })).toString('base64');
        const response = await serviceGetProveedores(query);

        setAbogados(response);
    }
    const hoy=()=>{
        const fecha=new Date()
        const hoy=fecha.toISOString().split("T")[0]
        return hoy
    }
    const refreshCntCargasRespaldo = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: implicado?.IdImplicado })).toString('base64');
        const response = await serviceGetDatosImplicado(query);

        setCntCargasRespaldo(response && response.length > 0 ? response[0]?.CntCargasRespaldoObjCIAs : null);
    }
    const handleChangeFile = (file) => {
        setFieldTouched("file", true, false);

        if (file && implicado?.FormatoArchRespaldoObjCIAs) {
            const formatosPermitidos = implicado.FormatoArchRespaldoObjCIAs
                .split(/[;,]/)
                .map(f => f.trim().replace('.', '').toLowerCase())
                .filter(f => f);
            const extension = file.name.split('.').pop().toLowerCase();

            if (formatosPermitidos.length && !formatosPermitidos.includes(extension)) {
                setFieldValue("file", undefined, false);
                fileRef.current.value = "";
                setFieldError("file", `Formato no permitido.`);
                return;
            }
        }
        setFieldValue("file", file, false);
        setFieldError("file", undefined);
    }
    const handleChangeMontoCosto = (value) => {
        setFieldValue('montoRecobro', validateMontoMoneda(Math.round((Number(value) * Number(values.porcConvenio) / 100)), 'reset_format'));
        setStateMontoRecobro(validateStateMonto(Number(value) * Number(values.porcConvenio) / 100));
    }
    const handleChangeConvenio = (value) => {
        setBlur(true);
     
        setFieldValue('montoRecobro', validateMontoMoneda(Math.round((Number(stateMontoCosto) * Number(value) / 100)), 'reset_format'));
        setStateMontoRecobro(validateStateMonto(Number(stateMontoCosto) * Number(value) / 100));
    }
    const validateMontoMoneda = (value, action) => {
        if (action === 'format') return formatoTest(value, true);
        else {
            if (Number(values.moneda) === 30001) return formatoTest(value, false);
            else return formatoTest(value, true);
        }
    }
    const validateStateMonto = (value) => {
        if (Number(values.moneda) === 30001) return formatoTestUS(value, false);
        else return formatoTestUS(value, true);
    }
    const handleFocusBlur = (action, type, value) => {
        if (action === "focus") {
            setBlur(false);
            if (type === "montoNetoApr") setFieldValue([type], stateMontoCosto);
            else setFieldValue([type], validateStateMonto(stateMontoRecobro));
        } else {
            setBlur(true);
            if (type === "montoNetoApr") setFieldValue([type], validateMontoMoneda(stateMontoCosto, 'format'));
            else setFieldValue([type], validateMontoMoneda(stateMontoRecobro, 'format'));
        }
    }
    const obtenerDetalle = (item, color, nivel) => {

    }
    return (
        <Fragment>
            <Card className='mt-2'>
                <Card.Header as='h6' style={{ backgroundColor: "rgb(209, 242, 235)", color: 'color: rgb(255, 255, 255)' }}>
                    {cfg_form && cfg_form["aprobobjcartacobrotercero-subtitle2"]}
                </Card.Header>

                <Card.Body>
                    <Container>
                        <Row>
                            <Col md='3' className='mb-3'>
                                <Form.Label className="label is_required">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-cmb-clasrpta"]}
                                </Form.Label>
                                <Form.Select
                                    name='clasificaRespuesta'
                                    value={values.clasificaRespuesta}
                                    onChange={e => { handleChange(e); setEstadoSituacion(null); setClasRespuesta(e.target.value); handleAbogados(false); }}
                                    onBlur={handleBlur}>

                                    <option value={''}>Seleccione...</option>
                                    {respuestas && respuestas
                                        .filter(p => p.agrupacion === 235005)
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {errors.clasificaRespuesta && touched.clasificaRespuesta &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.clasificaRespuesta}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='3' className='mb-3'>
                                <Form.Label className="label is_required">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-cmb-motivo"]}
                                </Form.Label>
                                <Form.Select
                                    name='motivoRespuestaCIA'
                                    value={values.motivoRespuestaCIA}
                                    onChange={e => {handleChange(e); handleMotivo(e.target.value);}}
                                    onBlur={handleBlur}>

                                    <option value={''}>Seleccione...</option>
                                    {motivos && motivos
                                        .filter(m => values.clasificaRespuesta !== "" && Number(m.agrupacion) === Number(values.clasificaRespuesta))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {errors.motivoRespuestaCIA && touched.motivoRespuestaCIA &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.motivoRespuestaCIA}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='2' className='mb-3'>
                                <Form.Label className="label is_required">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-input-fecharpta"]}
                                </Form.Label>
                                <Form.Control
                                    type="date"
                                    name='fechaRespuesta'
                                    value={values.fechaRespuesta}
                                    onChange={e => handleChange(e)}
                                    onBlur={handleBlur}>
                                </Form.Control>
                                {errors.fechaRespuesta && touched.fechaRespuesta &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.fechaRespuesta}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='2' className='mb-3'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-estado"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {estadoSituacion && estadoSituacion?.glosaEstado}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-3'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-sgteaccion"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {estadoSituacion && estadoSituacion?.glosaAccion}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col md='3' className='mb-2'>
                                <Form.Label className="label is_required">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-input-montonetoapr"]}
                                </Form.Label>
                                <Form.Control
                                    name='montoNetoApr'
                                    value={values.montoNetoApr}
                                    onChange={e => { handleChange(e); handleChangeMontoCosto(e.target.value); setStateMontoCosto(e.target.value) }}
                                    onBlur={e => { handleBlur(e); handleFocusBlur('blur', 'montoNetoApr', e.target.value) }}
                                    onFocus={e => handleFocusBlur('focus', 'montoNetoApr', e.target.value)}
                                    onKeyPress={(e) => moneyPunto(e, Number(values.moneda) !== 30001)}
                                >
                                </Form.Control>
                                {errors.montoNetoApr && touched.montoNetoApr &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.montoNetoApr}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='2'>                        
                                <Form.Label className="label is_required">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-input-porcrecapr"]}
                                </Form.Label>
                                <Form.Control
                                    name='porcConvenio'
                                    maxLength={5}
                                    value={values.porcConvenio}
                                    onChange={e => { handleChange(e); handleChangeConvenio(e.target.value)  }}
                                    onBlur={handleBlur}
                                    onKeyPress={(e) => percent(e)}>
                                </Form.Control>
                                {errors.porcConvenio && touched.porcConvenio &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.porcConvenio}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='3'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-mtorecobro"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {values.montoRecobro}
                                </Form.Text>
                            </Col>
                            { showAbogados &&
                            <Col md='2' className='mb-2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-cmb-abogados"]}
                                </Form.Label>
                                <Form.Select
                                    name='abogado'
                                    value={values.abogado}
                                    onChange={e => handleChange(e)}
                                    onBlur={handleBlur}>
                                    <option value={''}>Seleccione...</option>
                                    {abogados && abogados
                                        .map((m) => (<option key={m.id} value={m.id}>{m.nombre}</option>))
                                    }
                                </Form.Select>
                                {errors.abogado && touched.abogado &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.abogado}
                                    </Form.Text>
                                }
                            </Col>
                            }   
                            <Col md='2' className='mb-2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-cmb-tiposiniestro"]}
                                </Form.Label>
                                <Form.Select
                                    name='tipoSiniestroIM'
                                    value={values.tipoSiniestroIM}
                                    onChange={e => handleChange(e)}
                                    onBlur={handleBlur}>
                                    <option value={''}>Seleccione...</option>
                                    {tiposSiniestro && tiposSiniestro
                                        .map((m) => (<option key={m.id} value={m.id}>{m.nombre}</option>))
                                    }
                                </Form.Select>
                                {errors.tipoSiniestroIM && touched.tipoSiniestroIM &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.tipoSiniestroIM}
                                    </Form.Text>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md='6'>
                                <Form.Label className='label is_required'>
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-input-comentario"]}
                                    <small style={{ color: 'lightgrey' }}> (Se incluye a correo notificación)</small>
                                </Form.Label>
                                <br />
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name='comentarioAnalista'
                                    value={values.comentarioAnalista}
                                    onChange={e => handleChange(e)}
                                    onBlur={handleBlur}
                                />
                                {errors.comentarioAnalista && touched.comentarioAnalista &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.comentarioAnalista}
                                    </Form.Text>
                                }
                            </Col>
                            <Col md='6'>
                                <Form.Label className='label'>Correlativo Sura</Form.Label>
                                <Form.Control
                                    name='correlativoSura'
                                    value={values.correlativoSura}
                                    onChange={e => handleChange(e)}
                                    onBlur={handleBlur}
                                    className='mb-2'
                                    type='number'
                                    min={0}
                                    max={99}
                                    style={{ width: '80px' }}
                                />
                                <Form.Label className="label">
                                    {cfg_form && cfg_form["aprobobjcartacobrotercero-input-subirarchivo"]}
                                    {isValidParam(cntCargasRespaldo) &&
                                        <span className='ms-2' style={{ fontSize: '13px' }}>
                                            (<FaFileAlt className='mx-1' color='#2E6EA5' /><strong>Cargados: {cntCargasRespaldo}</strong>)
                                            <FaSyncAlt
                                                className='ms-1'
                                                color='gray'
                                                title="Refrescar cantidad de cargados"
                                                style={{ cursor: 'pointer' }}
                                                onClick={refreshCntCargasRespaldo}
                                            />
                                        </span>
                                    }
                                </Form.Label>
                                <div className='d-flex gap-2 align-items-start'>
                                    <Form.Control
                                        name='file'
                                        type="file"
                                        ref={fileRef}
                                        onChange={e => handleChangeFile(e.currentTarget.files[0])}
                                        onBlur={handleBlur}>
                                    </Form.Control>
                                    <OverlayTrigger placement='top' overlay={<Tooltip>Cargar Documento</Tooltip>}>
                                        <span>
                                            <Button
                                                type="button"
                                                variant='outline-secondary'
                                                disabled={!values.file}
                                                onClick={handleCargaDocumento}>
                                                <BsCloudUpload size={18} color='#2E6EA5' />
                                            </Button>
                                        </span>
                                    </OverlayTrigger>
                                </div>
                                {errors.file && touched.file &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.file}
                                    </Form.Text>
                                }
                                {implicado?.FormatoArchRespaldoObjCIAs &&
                                    <Form.Text className='text-muted d-block'>
                                        Formatos permitidos: {implicado.FormatoArchRespaldoObjCIAs}
                                    </Form.Text>
                                }
                            </Col>                            
                        </Row>                        
                        <br></br>
                        <Destinatarios
                         cfg_form={cfg_form} 
                         idCaso={idCaso} 
                         idImplicado={implicado?.IdImplicado}
                         idCiaImplicado={implicado && implicado.IdCiaImplicado}
                         destinatarios={destinatarios}
                         setDestinatarios={setDestinatarios}
                         clasificaRespuesta={values.clasificaRespuesta}
                         motivoRespuestaCIA={values.motivoRespuestaCIA}
                         estadoSituacion={estadoSituacion}
                         idAbogado={values.abogado}
                        />
                    </Container>
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default FormAprobacionObjecion;